import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import {observer} from 'mobx-react'
import {Tag} from 'antd'

import styles from './styles.scss'
import {TWO_FA_STATUS} from '@/constants/playwright-ids'

export type TwoFALabelProps = {
    isEnabled: boolean
    isLoading: boolean
}

export const TwoFALabel: React.FC<TwoFALabelProps> = observer(({isEnabled, isLoading}) => {
    const { t } = useTranslation()
    const color = isEnabled ? 'green' : 'grey'
    const text = isEnabled ? t('TwoFALabel.activated') : t('TwoFALabel.disabled')

    return (
        <Tag color={color} className={classNames(styles.root, {[styles.visible]: !isLoading})} data-test-id={TWO_FA_STATUS}>
            {text}
        </Tag>
    )
})
